var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: " transition-transform duration-300 group-hover:rotate-12 group-hover:scale-125",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M6.412 12.331a0.672 0.672 0 0 1 -0.669 0.669h-1.772a0.223 0.223 0 0 1 -0.222 -0.225V5.016a0.223 0.223 0 0 1 0.222 -0.222h1.772a0.669 0.669 0 0 1 0.669 0.669zm9.484 -0.266a1.469 1.469 0 0 1 -1.103 0.503h-3.022c0.378 1.091 0.519 1.444 0.581 2.047a2.362 2.362 0 0 1 -1.378 2.378 0.799 0.799 0 0 1 -1.166 -0.653v-0.819a4.231 4.231 0 0 0 -0.528 -2.194 3.634 3.634 0 0 0 -1.613 -1.397 4.688 4.688 0 0 0 -0.809 -0.319V6.119a1.406 1.406 0 0 0 0.528 -0.338 1.913 1.913 0 0 1 1.347 -0.556h4.147a2.942 2.942 0 0 1 2.903 2.516l0.45 3.166a1.459 1.459 0 0 1 -0.338 1.159"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisLikeIcon);
export default __webpack_public_path__ + "static/media/disLike_icon.b45a9c9377eb7b568cd694749b6b67fb.svg";
export { ForwardRef as ReactComponent };